// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__Gdqwp","text":"Spinner_text__BQYQa"};